import React, { useEffect, useRef, useState } from 'react';
import Loader from 'components/CustomComponents/Loader';
import { retrieveData } from 'helpers/utils/Utils';
import { GetApiHeadersWithBearer, GetRequest } from 'network/NetworkUtils';
import { useDispatch, useSelector } from 'react-redux';
import { GET_MASTER_BILLERS } from 'network/URLConstants';
import { STATUS_SUCCESS_CODE } from 'network/URLConstants';
import CustomDropdown from "../../../../../CustomComponents/CustomDropDown"
import CustomTextInput from "../../../../../CustomComponents/CustomtextInput"
import { useTranslation } from "react-i18next";
import Yellow from '../../../../../../assets/smi-kudzu-images/yellow.png'
import { handleAmountInputLimitTo2decimal } from 'utils';
import CustomDatePicker from 'components/CustomComponents/CustomDateInput';
import enableArrow from '../../../../../../assets/smi-kudzu-images/enable_arrow.png'
import disableArrow from '../../../../../../assets/smi-kudzu-images/disable_arrow.png'

const AddNewBiller = ({ getStates, getCountries, onCancelButton, newBiller, submitBiller, onOpenSubmitBiller, frequency , submitNewBillerRequest}) => {
    const accessToken = useSelector((state) => state.accessToken);
    const SelectedBillers = useSelector(state => state.selectedBillerType);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const [billerNameError, setBillerNameError] = useState('')
    const [billerName, setBillerName] = useState()
    const [enteredAccNumber, setEnteredAccountNumber] = useState()
    const [reEnteredAccNumber, setReEnteredAccNumber] = useState()
    const [enteredAccErr, setEnteredAccErr] = useState('');
    const [reEnterErrMesg, setReEnterErrMsg] = useState('')
    const [address1, setAddress1] = useState()
    const [address1ErrMsg, setAddress1ErrMsg] = useState('')
    const [address2, setAddress2] = useState()
    const [address2ErrMsg, setAddressErrMsg] = useState('')
    const [city, setCity] = useState()
    const [cityErrMsg, setCityErrMsg] = useState('')
    const [zipCode, setZipCode] = useState()
    const [zipErrMsg, setZipErrMsg] = useState('')
    const [selectedStates, setSelectedStates] = useState()
    const [selectedCountrie, setSelectedCountrie] = useState()
    const [phoneNumber, setPhoneNumbers] = useState()
    const primaryAcc = useSelector(x => x.primaryAccount)
    const [selectedFrequency, setSelectedFrequency] = useState()
    const [enteredAmount, setEnteredAmount] = useState()
    const [oneTimeSelectedDate, setOneTimeSelectedDate] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const billPaymentsMetaData = useSelector(x => x.billPaymentsMetaData)

    const onDateChange = (date, type) => {
        if (type == 'oneTime') {
            setOneTimeSelectedDate(date)
            dispatch({ type: 'NEW_BILLER_ONE_TIME', payload: { newBillerOneTimeDate: date } })
        } else if (type == 'recurringStartDate') {
            setStartDate(date)
            dispatch({ type: 'NEW_BILLER_RC_START', payload: { newBillerRcStartDate: date } })
            setEndDate(null)
            dispatch({ type: 'NEW_BILLER_RC_END', payload: { newBillerRcEndDate: null } })
        } else if (type == 'recurringEndDate') {
            setEndDate(date)
           dispatch({ type: 'NEW_BILLER_RC_END', payload: { newBillerRcEndDate: date } })
        }
    }

    // End date must be at least the day after start date
    const endDateMinDate = startDate ? (() => {
        const d = new Date(startDate);
        d.setDate(d.getDate() + 1);
        return d;
    })() : undefined;

    const hasBillerName = (billerName ?? '').trim().length > 0;
    const hasAccountNumber = (enteredAccNumber ?? '').trim().length > 0;
    const hasReEnteredAccountNumber = (reEnteredAccNumber ?? '').trim().length > 0;
    const accountNumbersMatch =
        hasAccountNumber &&
        hasReEnteredAccountNumber &&
        (enteredAccNumber ?? '').trim() === (reEnteredAccNumber ?? '').trim();
    const hasAddress1 = (address1 ?? '').trim().length > 0;
    // Address 2 is optional
    const hasCity = (city ?? '').trim().length > 0;
    const hasState = selectedStates != null && Object.keys(selectedStates || {}).length > 0;
    const hasZip = (zipCode ?? '').toString().trim().length === 5;
    const hasCountry = selectedCountrie != null && Object.keys(selectedCountrie || {}).length > 0;
    const phoneDigits = (phoneNumber ?? '').toString().replace(/\D/g, '');
    const hasPhone = phoneDigits.length === 10;
    const isNextDisabled =
        !hasBillerName ||
        !hasAccountNumber ||
        !hasReEnteredAccountNumber ||
        !accountNumbersMatch ||
        !hasAddress1 ||
        !hasCity ||
        !hasState ||
        !hasZip ||
        !hasCountry ||
        !hasPhone;

    const hasFrequency = selectedFrequency != null && Object.keys(selectedFrequency).length > 0;
    const hasAmount = Boolean(enteredAmount) && parseFloat(String(enteredAmount).replace(/[$,]/g, '')) > 0;
    const hasDates = selectedFrequency?.Type === 'O'
        ? Boolean(oneTimeSelectedDate)
        : Boolean(startDate && endDate);
    const isSubmitDisabled = !hasFrequency || !hasAmount || !hasDates;    


    return (
        <>
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
                            animate__animated animate__fadeInRight '>
                <div className='md:w-[100%] sm:w-[100%] w-full '>

                    {newBiller &&
                        <>
                            <div className={`flex flex-col sm:mx-0 mx-4`}>
                                {!kudzuPlusTrue && (
                                    <hr className="w-[80%] mx-auto border-2 border-t border-[#A3CEBB]" />
                                )}
                                <div className='md:w-[80%] sm:w-[80%] w-[80%] mx-auto mt-6'>
                                    <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('ADD_NEW_BILLER_MAIN_HEADING'))}</p>
                                </div>

                                <div className='flex justify-center'>
                                    <div className='md:w-[60%] sm:w-[60%] w-[60%] md:pt-6 pt-10 '>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Biller Name")}</p>
                                            <CustomTextInput

                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setBillerName(inputValue)
                                                    if (inputValue.length <= 50) {
                                                        dispatch({ type: 'NEW_BILLER_NAME', payload: { newBillerName: inputValue } });
                                                    } else {
                                                        console.log('Input length exceeds 50 characters');
                                                    }
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={billerName ? `${billerName}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Biller Account Number")}</p>


                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setEnteredAccountNumber(value);
                                                    dispatch({ type: 'NEW_BILLER_ACCOUNT_NUMBER', payload: { newAccountNumber: value } });
                                                    // Live-validate match with re-entered account number
                                                    if ((reEnteredAccNumber ?? '').length > 0) {
                                                        if (value !== reEnteredAccNumber) {
                                                            setReEnterErrMsg('Account numbers do not match');
                                                        } else {
                                                            setReEnterErrMsg('');
                                                        }
                                                    }
                                                }}

                                                // onBlur={(e) => handleOnBlurEnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                              //  numbersOnly={true}
                                                value={enteredAccNumber}
                                                style={{ width: '100%', height: '51px' }}
                                            //error={enteredAccErr}
                                            />
                                        </div>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("RE_ENTERED_BILLER_ACC_NUMBER")}</p>
                                            <CustomTextInput
                                                maxLength={35}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setReEnteredAccNumber(value);
                                                    // Live-validate match with first account number
                                                    if ((enteredAccNumber ?? '').length > 0) {
                                                        if (value !== enteredAccNumber) {
                                                            setReEnterErrMsg('Account numbers do not match');
                                                        } else {
                                                            setReEnterErrMsg('');
                                                        }
                                                    } else {
                                                        // If first field is empty, clear mismatch error and rely on required validation if any
                                                        setReEnterErrMsg('');
                                                    }
                                                }}

                                                // onBlur={(e) => handleOnBlurRe_EnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                               // numbersOnly={true}
                                                value={reEnteredAccNumber}
                                                style={{ width: '100%', height: '51px' }}
                                                error={reEnterErrMesg}
                                            />
                                        </div>
                                        <div className="mb-8 bg-[#DAE2E8] rounded-lg px-4 py-3 flex items-center gap-3">
                                            <img src={Yellow} alt="warning" className="w-5 h-5 shrink-0" />
                                            <p className="font-hanken-grotesk font-[600] text-[14px] leading-[20px] text-[#1E1E1E]">
                                                {t("BILL_PAYMENTS_BOTH_ACCOUNT_NUMBERS_SHOULD_MATCH")}
                                            </p>
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address 1")}</p>
                                            <CustomTextInput

                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setAddress1(inputValue)
                                                    dispatch({ type: 'BILLER_ADDRESS_ONE', payload: { billerAddressOne: inputValue } });
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={address1 ? `${address1}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Address 2")}</p>
                                            <CustomTextInput
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setAddress2(inputValue)
                                                    dispatch({ type: 'BILLER_ADDRESS_Two', payload: { billerAddressTwo: inputValue } });
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={address2 ? `${address2}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                        </div>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                                                           sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                                                     ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("CITY")}</p>
                                            <CustomTextInput
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    setCity(inputValue)
                                                    dispatch({ type: 'BILLER_ADDRESS_CITY', payload: { billerAddressCity: inputValue } });
                                                }}
                                                // onBlur={(event) => handleOnBlur(event)}
                                                value={city ? `${city}` : ''}
                                                // error={billerNameError}
                                                //placeholder={"First name"}
                                                inputWidth={`w-full`}
                                                autoFocus={true}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("STATE")}</p>
                                            <CustomDropdown
                                                options={getStates || []}
                                                onSelect={(option) => {
                                                    setSelectedStates(option)
                                                    dispatch({ type: 'BILLER_ADDRESS_STATES', payload: { billerAddressStates: option } });
                                                }}
                                                selectedAccountType={selectedStates}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("ZIP CODE")}</p>
                                            <CustomTextInput
                                                maxLength={5}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setZipCode(value);
                                                    dispatch({ type: 'BILLER_ADDRESS_ZIPCODE', payload: { billerAddressZipCode: value } });
                                                }}

                                                // onBlur={(e) => handleOnBlurEnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                                numbersOnly={true}
                                                value={zipCode}
                                                style={{ width: '100%', height: '51px' }}
                                            //error={enteredAccErr}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Country")}</p>
                                            <CustomDropdown
                                                options={getCountries || []}
                                                onSelect={(option) => {
                                                    setSelectedCountrie(option)
                                                    dispatch({ type: 'BILLER_ADDRESS_COUNTRIES', payload: { billerAddressCuntries: option } });
                                                }}
                                                selectedAccountType={selectedCountrie}
                                            />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Phone Number")}</p>
                                            <CustomTextInput
                                                maxLength={10}
                                                autoFocus={true}
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    setPhoneNumbers(value);
                                                    dispatch({ type: 'BILLER_ADDRESS_PHONE', payload: { billerAddressPhone: value } });
                                                }}

                                                // onBlur={(e) => handleOnBlurEnteredAccountNumberInfo(e)}
                                                disallowSpaces={true}
                                                numbersOnly={true}
                                                value={phoneNumber}
                                                style={{ width: '100%', height: '51px' }}
                                            //error={enteredAccErr}
                                            />

                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-row sm:justify-end w-[85%] justify-between mb-16'>
                                    <button
                                        onClick={onCancelButton}
                                        className='font-hanken-grotesk
                                    text-[var(--btn-clr-cards)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px]
                                    text-[16px]'>{t("Cancel")}</button>
                                    <button
                                        onClick={onOpenSubmitBiller}
                                        disabled={isNextDisabled}
                                        className={`font-hanken-grotesk text-[var(--input-text)] font-[700] lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] sm:ml-10 ${isNextDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        {t("Next")}
                                    </button>
                                           <img src={isNextDisabled ? disableArrow : enableArrow} alt="arrow" className='h-[13px] w-[13px] mt-3 ml-2 mb-2
                                                          sm:h-[10px] sm:w-[11px] md:h-[13px] md:w-[13px]' />
                                </div>
                            </div>
                        </>
                    }
                    {submitBiller &&
                        <>
                            <div className={`flex flex-col sm:mx-0 mx-4`}>
                                {!kudzuPlusTrue && (
                                    <hr className="w-[80%] mx-auto border-2 border-t border-[#A3CEBB]" />
                                )}
                                <div className='md:w-[80%] sm:w-[80%] w-[80%] mx-auto mt-6'>
                                    <p className={`text-start sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                                            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                                            sm:mx-0 mx-4 ${kudzuPlusTrue ? "text-white" : ""}`}>{(t('ADD_NEW_BILLER_MAIN_HEADING'))}</p>
                                </div>
                                <div className='flex justify-center'>
                                    <div className='md:w-[60%] sm:w-[60%] w-[60%] md:pt-6 pt-10 '>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("FROM")}</p>
                                            <CustomDropdown
                                               // title={t('FROM')}
                                                hideArrow={true}
                                                selectedAccountType={primaryAcc}
                                                hrbg='bg-dropdown-sky'
                                                 balanceFontColor={kudzuPlusTrue ? 'text-[#ffffff]' :'text-[#559C7E]'} />
                                        </div>

                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Frequency")}</p>
                                            <CustomDropdown
                                                options={frequency || []}
                                                onSelect={(option) => {
                                                    setSelectedFrequency(option)
                                                    dispatch({ type: 'NEW_BILLER_FREQUENCY', payload: { newBillerFrequency: option } });
                                                }}
                                                selectedAccountType={selectedFrequency}
                                            />
                                        </div>
                                        <div className='mb-8'>
                                            <p className={`font-hanken-grotesk text-[var(--text-clr-textarea)] uppercase lg:text-[13px] md:text-[13px]
                                                            sm:text-[11px] text-[13px] font-[600] tracking-[2px] pb-2
                                                   ${kudzuPlusTrue ? '' : 'opacity-[50%]'}`}>{t("Bill Amount")}</p>
                                            <CustomTextInput
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    const formattedAmount = handleAmountInputLimitTo2decimal(inputValue)
                                                    setEnteredAmount(formattedAmount)
                                                    dispatch({ type: 'NEW_BILLER_AMOUNT', payload: { newBillerAmount: formattedAmount } });
                                                }}
                                                value={enteredAmount ? `$${enteredAmount}` : ''}
                                                placeholder={"$ 0"}
                                                inputWidth='w-full'
                                            />
                                        </div>

                                        <div className='mb-8'>

                                            {selectedFrequency?.Type === "O" &&
                                                <CustomDatePicker
                                                    selectedDate={startDate}
                                                    onDateChange={(date) => onDateChange(date, 'oneTime')}
                                                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    disabledDates={[]}
                                                    title="Next Payment DATE"
                                                    hrbg="bg-dropdown-sky"
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }
                                        </div>
                                        <div className='mb-8'>
                                            {selectedFrequency?.Type !== "O" &&
                                                <CustomDatePicker
                                                    selectedDate={startDate}
                                                    onDateChange={(date) => onDateChange(date, 'recurringStartDate')}
                                                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    title="Next Payment DATE"
                                                    hrbg='bg-dropdown-sky'
                                                    disabledDates={[]}
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }

                                        </div>
                                        <div className='mb-12'>
                                            {selectedFrequency?.Type !== "O" &&
                                                <CustomDatePicker
                                                    selectedDate={endDate}
                                                    onDateChange={(date) => onDateChange(date, 'recurringEndDate')}
                                                    minDate={endDateMinDate}
                                                    maxDate={billPaymentsMetaData?.EndDate}
                                                    disabledDates={[]}
                                                    title="End Date"
                                                    hrbg='bg-dropdown-sky'
                                                    placeHolder={t('Month_Day_Year')}
                                                />
                                            }
                                        </div>

                                         <div className='flex flex-col gap-4 justify-center items-center w-full mb-20'>
                                            <button
                                               onClick={submitNewBillerRequest}
                                               disabled={isSubmitDisabled}
                                                class={`font-hanken-grotesk lg:text-[18px] md:text-[17px]
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-white  border-2 px-2 py-4 border-[#2965FB] w-full ${isSubmitDisabled ? 'bg-[#94C3E8] border-[#94C3E8] cursor-not-allowed' : "bg-[#2965FB] border-[#2965FB] cursor-pointer"}`}
                                            >{t("Submit")}</button>

                                             <button className='focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[] text-[#2965FB] cursor-pointer  px-2 py-4 border-[#4B70B9] w-full' onClick={onCancelButton}>{t("Cancel")}</button>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </>
                    }

                </div>
            </div>
        </>
    )
}
export default AddNewBiller;